module.exports = __webpack_public_path__ + "static/z_tall_flcuptodate-5d93bcbefca3eaf462878f1bf3f0b83d.jpg";